(() => {
  const instances = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('[data-announcement-ticker]').forEach(bar => {
      if (instances.has(bar)) return;
      const track = bar.querySelector('.announcement__track');
      const group = track?.querySelector('.announcement__group');
      if (!group) return;
      const originals = Array.from(group.children).map(item => item.cloneNode(true));
      let lastWidth = -1;
      function duplicate(item) {
        const copy = item.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('a').forEach(link => link.tabIndex = -1);
        return copy;
      }
      function fill() {
        const width = bar.clientWidth;
        if (!width || !track.getBoundingClientRect().height) return;
        group.replaceChildren(...originals.map(item => item.cloneNode(true)));
        track.querySelectorAll('.announcement__group').forEach(item => {
          if (item !== group) item.remove();
        });
        const cycleWidth = group.getBoundingClientRect().width;
        if (!cycleWidth) return;
        const repeats = Math.max(1, Math.ceil((width + 1) / cycleWidth));
        for (let i = 1; i < repeats; i++) originals.forEach(item => group.append(duplicate(item)));
        const copy = duplicate(group);
        track.append(copy);
        lastWidth = width;
      }
      const observer = new ResizeObserver(() => {
        if (bar.clientWidth !== lastWidth) fill();
      });
      observer.observe(bar);
      instances.set(bar, observer);
      fill();
      document.fonts?.ready.then(fill);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-announcement-ticker]').forEach(bar => {
      instances.get(bar)?.disconnect();
      instances.delete(bar);
    });
  });
})();
